import {styled} from "@mui/material";
import {grey} from "@mui/material/colors";
import {defaultTabHintClass} from "../../../misc/userpref/useDefaultTab";

export const TabWrapper = styled("div")(props => ({
    backgroundColor: grey["100"],
    borderBottom: "1px solid " + grey["300"],
    display: "flex",
    width: "100%",

    "& .MuiTabs-root": {
        minHeight: 20,
    },

    "& .MuiTab-root": {
        paddingTop: 4,
        paddingBottom: 4,
        minHeight: 20,
    },
    "& .MuiTabs-flexContainer": {
        flexWrap: "wrap",
    },
    [`&:hover .${defaultTabHintClass}`]: {
        opacity: 1,
    },
}))
